import Vue from "vue";
import Router from "vue-router";
import firebase from "firebase/app";

import SignIn from "./views/SignIn.vue";
import Group from "./views/Group.vue";
import View from "./views/View.vue";
import KnowledgeBase from "./views/KnowledgeBase.vue";

import ResetPassword from "./views/ResetPassword.vue";
import Hub from "./views/Hub.vue";
import Dashboard from "./views/Dashboard.vue";
import Profile from "./views/Profile.vue";
import ResultsPersonality from "./views/ResultsPersonality.vue";
import ResultsPathways from "./views/ResultsPathways.vue";
import ResultsCombination from "./views/ResultsCombination.vue";
import TestPersonality from "./views/TestPersonality.vue";
import TestPathways from "./views/TestPathways.vue";
import GroupReport from "./views/GroupReport.vue";

Vue.use(Router);

const router = new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "*",
      redirect: "/",
    },
    {
      path: "/",
      name: "dashboard",
      component: Dashboard,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/results/insights",
      name: "resultspersonality",
      component: ResultsPersonality,
    },
    {
      path: "/group",
      name: "group",
      component: Group,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/view",
      name: "view",
      component: View,
      props: true,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/knowledgebase",
      name: "knowledgebase",
      component: KnowledgeBase,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/report",
      name: "report",
      props: true,
      component: GroupReport,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/profile",
      name: "profile",
      component: Profile,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/hub",
      name: "hub",
      component: Hub,
    },
    {
      path: "/results/pathways",
      name: "resultspathways",
      component: ResultsPathways,
    },
    {
      path: "/results",
      name: "resultcombination",
      component: ResultsCombination,
    },
    {
      path: "/test/personality",
      name: "testpersonality",
      component: TestPersonality,
      props: true,
    },
    {
      path: "/test/pathways",
      name: "testpathways",
      component: TestPathways,
      props: true,
    },
    {
      path: "/sign-in",
      name: "signin",
      component: SignIn,
    },
    {
      path: "/reset-password/",
      name: "resetpassword",
      component: ResetPassword,
    },
  ],
});

router.beforeEach((to, from, next) => {
  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

  if (requiresAuth && !currentUser) {
    next("sign-in");
  } else {
    next();
  }
});

export default router;
